import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { callNotify } from "../../../..";
import Icon, { ICON_NAME } from "../../../../components/Icon";
import modal from "../../../../components/Popup/ModalCustom";
import { openOpInfo } from "../../../../components/Popup/PopupOpInfo";
import { OperationProvider } from "../../../../contexts/OperationContext";
import { openPage } from "../../../../util/library/Router";
import { OpService } from "../../../../util/services/operation";
import { getStore } from "../../../../util/store/store";
import {
    OP_STATUS,
    OPERATION_TYPE,
    PATHNAME,
} from "../../../../util/varibles/constants";
import { showErrorResponse } from "../../../../util/varibles/global";
import {
    IOperation
} from "../../../../util/varibles/interface";
import EventView from "../../_components/ContentOperation/EventView";
import HarvestView from "../../_components/ContentOperation/HarvestView";
import ServiceView from "../../_components/ContentOperation/ServiceView";
import TransportView from "../../_components/ContentOperation/TransportView";
import TreatmentView from "../../_components/ContentOperation/TreatmentView";
import { deleteSuccess } from "../../_components/Menu/actions";
import { selectPlan } from "../../constants";
import Loading from "../../Plan/Calendar/Loading";
import { default as stylesContainer, default as stylesOp } from "../../Plan/Calendar/Operations/Operation/style.module.scss";
import { planOpActions } from "../../reducer";
import Drag from "./Drag";
import styles from "./style.module.scss";

const renderContent = (
    data: IOperation,
    status: OP_STATUS = OP_STATUS.CANCELED
) => {
    const { operation_type } = data.operation;
    const common = {
        status,
        data,
        isOwn: true,
    };
    switch (operation_type) {
        case OPERATION_TYPE.EVENT:
            return <EventView {...common} />;
        case OPERATION_TYPE.HARVEST:
            return <HarvestView {...common} />;
        case OPERATION_TYPE.TREATMENT:
            return <TreatmentView {...common} />;
        case OPERATION_TYPE.TRANSPORT:
            return <TransportView {...common} />;
        case OPERATION_TYPE.SERVICE:
            return <ServiceView {...common} />;
        default:
            return null;
    }
};
interface IProps {
    data: IOperation;
    status?: OP_STATUS;
    dragging?: boolean;

    onDragStart?(e: any, id: string): void;

    onDragEnd?(e: any): void;

    renewOp?(data: any): void;
}

const Operation: React.FC<IProps> = React.memo((props) => {
    const {
        data,
        status = OP_STATUS.CANCELED,
        dragging = false,
        onDragStart,
        onDragEnd,
        renewOp,
    } = props;
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const menu = [
        {
            key: "detail",
            onClick: openDetail,
            label: (
                <div className="menu-line">
                    <Icon icon={ICON_NAME.OPERATION_DETAIL} size={16} />
                    <div>Operation detail</div>
                </div>
            ),
        },
        {
            key: "revert",
            onClick: revert,
            label: (
                <div className="menu-line">
                    <Icon icon={ICON_NAME.REVERT} size={15} />
                    <div>Revert</div>
                </div>
            ),
        },
        {
            type: "divider",
        },
        {
            key: "delete",
            onClick: openDeleteDialog,
            label: (
                <div
                    className="menu-line"
                    data-danger={true}
                >
                    <Icon icon={ICON_NAME.DELETE} danger size={15} />
                    <div>Delete</div>
                </div>
            ),
        },
    ];

    function revert(e: any) {
        const event = e.domEvent ?? e;
        event.stopPropagation();
        const vessels = selectPlan.vessels(getStore());
        if (renewOp) {
            const vessel = vessels.find(item => item.id === data.operation.vessel_id);
            if (!vessel) {
                callNotify?.error({
                    title: "Revert failed",
                    description: `Can't find the vessel in the system`,
                });
            } else renewOp({ ...data, vessel });
        }
        return true;
    }

    function openDetail(e: any) {
        const event = e.domEvent ?? e;
        event.preventDefault();
        event.stopPropagation();
        const { tenant_id, id } = data.operation;
        openPage(`${PATHNAME.OPERATION}/${tenant_id}/${id}`);
        return false;
    }

    function openDeleteDialog(e: any) {
        const event = e.domEvent ?? e;
        event.preventDefault();
        event.stopPropagation();
        modal.confirm({
            content: "Are you sure you want to delete this operation?",
            ok: {
                click: () => {
                    const { id, operation_code } = data.operation;
                    setLoading(true);
                    OpService.delete(id)
                        .then(() => {
                            setLoading(false);
                            deleteSuccess([id], [operation_code], (ids) =>
                                dispatch(planOpActions.deleteOps(ids))
                            );
                        })
                        .catch((error) => {
                            setLoading(false);
                            if (
                                error.response &&
                                error.response.status.toString() === "445"
                            ) {
                                deleteSuccess([id], [operation_code], (ids) =>
                                    dispatch(planOpActions.deleteOps(ids))
                                );
                            } else showErrorResponse("Delete failed", error);
                        });
                },
            },
        });
        return false;
    }

    function openOperationPopup() {
        const vessels = selectPlan.vessels(getStore());
        const vessel = (vessels || []).find(item => item.id === data.operation.vessel_id);

        if (vessel)
            openOpInfo({ isEdit: false, data: { ...data, vessel } })
    }

    return (
        <div
            id={data.operation.id}
            data-loading={loading}
            className={[styles.operation, stylesOp.operation].join(" ")}
            data-status={status}
            onClick={openOperationPopup}
        >
            <div
                className={[
                    stylesContainer["content-wrapper"],
                    stylesContainer["layout"],
                    "text-truncate",
                ].join(" ")}
            >
                <OperationProvider isOwn={true} data={data}>
                    {renderContent(data, status)}
                </OperationProvider>]

                {!dragging && onDragStart && (
                    <Drag
                        menu={menu}
                        onDragStart={(e) => onDragStart(e, data.operation.id)}
                        onDragEnd={onDragEnd}
                    />
                )}
            </div>
            <Loading id={data.operation.id + '-loading'} loading={loading} isFull={false} />
        </div>
    );
});

export default Operation;
